<template>
    <v-dialog
        :value="showDialog"
        persistent
        max-width="550"
    >        
      <v-card>
        <v-card-title class="text-h5 green darken-2 white--text">Select Your Local</v-card-title>
        <v-card-text dark>
            <p class='mt-2'>These locals match the employer and job classification you selected.</p>
            <v-form>
              <v-select
                v-model="selection"
                :items="potentialUnits"
                item-value="unit_cst_recno"
                return-object
                label="Please select your local"
              >
                <template slot="selection" slot-scope="data">
                  <!-- HTML that describe how select should render selected items -->
                  {{ data.item.unit_common_name ? data.item.unit_common_name : data.item.unit_name }}
                </template>
                <template slot="item" slot-scope="data">
                  <!-- HTML that describe how select should render items when the select is open -->
                  {{ data.item.unit_common_name ? data.item.unit_common_name : data.item.unit_name }}
                </template>
              </v-select>
            </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>           
          <v-btn
            color="blue darken-1"
            text
            :disabled="selection == null"
            @click="$emit('close-dialog', selection);"
          >
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: 'MultiplePossibleUnitsDialog',
    data:() => ({ 
      selection:null
    }),
    props: {
        showDialog: Boolean,
        potentialUnits:  Array
    },
    watch:{
    }
  }
</script>